(() => {
  customElements.whenDefined('codex-routine-form').then(() => {
    if (customElements.get('codex-home-routine-form')) return;
    class CodexHomeRoutineForm extends customElements.get('codex-routine-form') {
      _updateOnetimeTrigger(option) {
        super._updateOnetimeTrigger(option);
        this._refreshHomePrices();
      }
      _syncPurchase() {
        super._syncPurchase();
        this._refreshHomePrices();
      }
      _refreshHomePrices() {
        const api = window.igData?.price;
        const price = (id, fallback) => {
          try {
            const value = api?.getPriceByVariantId?.(String(id));
            if (value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0) return Math.round(Number(value) * 100);
          } catch {}
          return Number(fallback);
        };
        const money = cents => this._igFmt(cents / 100);
        this.querySelectorAll('[data-routine-panel]').forEach(panel => {
          const sub = price(panel.dataset.routinePanel, panel.dataset.baseSub);
          const once = price(panel.dataset.oneTimeVariantId, panel.dataset.baseOnce);
          if (!Number.isFinite(sub) || !Number.isFinite(once)) return;
          const value = once + 2000;
          const savings = value > 0 ? Math.floor((value - sub) * 100 / value) : 0;
          const set = (selector, text) => { const node = panel.querySelector(selector); if (node) node.textContent = text; };
          set('[data-home-sub]', money(sub));
          set('[data-home-once]', money(once));
          set('[data-home-value]', money(value));
          set('[data-home-renewal]', panel.dataset.renewalTemplate.replace('__PRICE__', money(sub)));
          set('[data-home-savings]', panel.dataset.savingsTemplate.replace('__SAVINGS__', String(savings)));
          panel.dataset.refillLabel = panel.dataset.refillTemplate.replace('__PRICE__', money(sub));
        });
        const active = this.querySelector('[data-routine-panel]:not([hidden])');
        const refill = this.querySelector('.js-cr-refill');
        if (active && refill) refill.textContent = active.dataset.refillLabel;
      }
    }
    customElements.define('codex-home-routine-form', CodexHomeRoutineForm);
  });
})();
